export default __webpack_public_path__ + "static/media/insights-blue.bc20d18f.svg";